import { Icon, ICONS, colors } from '@creditsights/styleguide-web';
import classnames from 'classnames/bind';
import React, { ReactElement, useMemo } from 'react';
import useFetchUserProfile from '../../../../hooks/profile/useFetchUserProfile';
import styles from './InitialsIcon.module.scss';

const cx = classnames.bind(styles);

interface InitialsIconProps {
  isOpen: boolean;
}

const renderCaretIcon = (rotate: boolean) => (
  <div className={cx('icon', { rotate })}>
    <Icon name={ICONS.CaretDownFat} height={5} width={8.5} color={colors['white-color']} />
  </div>
);

const InitialsIcon = ({ isOpen }: InitialsIconProps): ReactElement => {
  const { data: profile } = useFetchUserProfile();

  const initials = useMemo(() => {
    return profile ? `${profile.firstName.charAt(0)}${profile.lastName.charAt(0)}`.toUpperCase() : '';
  }, [profile]);

  return (
    <div className={cx('body')}>
      <span className={cx('initials')}>{initials}</span>
      {renderCaretIcon(isOpen)}
    </div>
  );
};

export default InitialsIcon;
